/* global jQuery, console */

import { Module } from "wrapper6";

export default class ProductVariationImageHandler extends Module {

  ready() {
    const container = jQuery('div.mtt-product-card__text-wrap')

    if(!container) return

    /**
     * When mouseover on variations images, it will replace the src, srcset and href on the product card,
     * to match the variation.
     */
    container.on('mouseover', '.mtt-product-card__variations img', function () {
        const element = jQuery(this)
        const newVariationLink = element.parent().data('variation-link')
        const newImageSrc = element.attr('src')
        const newImageSrcset = element.attr('src')

        const productCartATag = element.closest('a')
        const imageTag = productCartATag.find('.mtt-product-card__image img')

        productCartATag.attr('href', newVariationLink)
        imageTag.attr('src', newImageSrc)
        imageTag.attr('srcset', newImageSrcset)
    })
  }

}


// WEBPACK FOOTER //
// ./resources/js/modules/_product-variation-image-handler.js